
// #region imports

// --- Angular
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// --- RxJs
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

// --- HS Code
import { RespondentDeclineStages } from '../../../models';
import { RespondentDeclineBaseService } from './respondent-decline-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class RespondentDeclineMockService extends RespondentDeclineBaseService {

  constructor(router: Router) {
    super(router);
  }

  resolveToken(token: string): void {
    this._emailAddress$.next('user@email.com');
    this._fullName$.next('Olive Green');
    this._tokenResolved$.next(true);
  }

  decline(token: string): void {
    this._declineStage$.next(RespondentDeclineStages.declining);
    of(token)
    .pipe(delay(5000))
    .subscribe((result) => {
      this._declineStage$.next(RespondentDeclineStages.declined);
    });
  }
}
